import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SiteContentContext = createContext({ content: null, refresh: () => {} });

export const SiteContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/site/content");
      setContent(r.data);
    } catch {
      // keep null — components will fallback to i18n defaults
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SiteContentContext.Provider value={{ content, refresh }}>
      {children}
    </SiteContentContext.Provider>
  );
};

export const useSiteContent = () => useContext(SiteContentContext);
